import { useEffect, useState } from "react";
import { useConf } from "../../context/account/paramsAccount";
import { FormattedMessage } from "react-intl";
import { handleInputChangePrestaConsommation } from "../../functions/inputFunctions/inputFunctions";
import { ListePresta } from "../../interface/retourPrestation/retourPrestation";
import { useError } from "../../context/erreur/erreurContext";
import NumericInput from "../kendo/numericInput";
interface DataSend {
    e_rpl_id: number;
    e_qte_consommee_uco: number | null;
    e_qte_ret_uret: number | null;
    e_qte_fact: number | null;
    e_uret_id: any;
}
const RenderConsommation = ({ sub, details, setDetails, parentId, isValid }: { sub: ListePresta, details: any, setDetails: any, parentId: any, isValid: boolean }) => {
    const { conf }: any = useConf()
    const { showError } = useError();

    const [dataSend, setDataSend] = useState<DataSend>({
        e_qte_consommee_uco: sub?.rpl_qte_casse_ukc,
        e_qte_ret_uret: sub?.rpl_qte_ret,
        e_qte_fact: sub?.rpl_qte_fact_uf,
        e_uret_id: null,
        e_rpl_id: parseInt(sub?.rpl_id)
    });
    function mergeDataSend(existing: any[] = [], newItem: any) {
        // Cherche si un élément avec le même e_rpl_id existe déjà
        const index = existing.findIndex(item => item.e_rpl_id === newItem.e_rpl_id);

        if (index !== -1) {
            // Remplace l'élément existant
            const updated = [...existing];
            updated[index] = { ...existing[index], ...newItem };
            return updated;
        }

        // Sinon, ajoute le nouvel élément
        return [...existing, newItem];
    }
    useEffect(() => {

        setDataSend({
            e_qte_consommee_uco: sub?.rpl_qte_casse_ukc,
            e_qte_ret_uret: sub?.rpl_qte_ret,
            e_qte_fact: sub?.rpl_qte_fact_uf,
            e_uret_id: null,
            e_rpl_id: parseInt(sub.rpl_id)
        })
    }, [sub?.rpl_qte_casse_ukc, sub?.rpl_qte_ret, sub?.rpl_qte_fact_uf])
    const findValidTarget = (node: any): any => {
        if (!node || node.v_reserve === true) return null;

        if (node.rpl_type === "A") return node;

        if (!Array.isArray(node.sous_categorie)) return null;

        for (const child of node.sous_categorie) {
            const found = findValidTarget(child);
            if (found) return found;
        }

        return null;
    };
    const hasADeep = (node: any, targetId: number): boolean => {
        if (!node) return false;

        if (
            node.rpl_type === "A" &&
            parseInt(node.rpl_id) === targetId
        ) {
            return true;
        }

        if (!Array.isArray(node.sous_categorie)) return false;

        return node.sous_categorie.some((child: any) =>
            hasADeep(child, targetId)
        );
    };

    useEffect(() => {

        setDetails((prevDetails: any) => {
            const updatePhase = (phase: any, fromReserve = false): any => {
                // if (phase?.v_reserve === true) {
                //     return phase;
                // }

                if (!phase || phase.rpl_id == null || phase.rpl_id === '') return phase;

                const isFromReserve = fromReserve || phase.v_reserve === true;
                // Si c'est un E, on descend dans les enfants
                if (phase?.rpl_type === "E" && Array.isArray(phase?.sous_categorie)) {
                    const hasP = phase?.sous_categorie.some((child: any) => child?.rpl_type === "P" && child?.v_reserve !== true);
                    if (hasP) {
                        return {
                            ...phase,
                            sous_categorie: phase?.sous_categorie.map((child: any) => {
                                if (child?.rpl_type === "P") {
                                    // Vérifie si ce P contient un descendant A avec l'id du dataSend
                                    const containsA = hasADeep(child, dataSend.e_rpl_id);



                                    if (containsA) {
                                        // ❌ Si le A vient d'une réserve → on ne merge PAS ici
                                        if (isFromReserve || child.v_reserve === true) {
                                            return child;
                                        }

                                        // ✅ Sinon comportement normal
                                        return {
                                            ...child,
                                            dataSend: mergeDataSend(child.dataSend, dataSend),
                                            sous_categorie: Array.isArray(child.sous_categorie)
                                                ? child.sous_categorie.map((c: any) =>
                                                    updatePhase(c, isFromReserve)
                                                )
                                                : child.sous_categorie,
                                        };
                                    }

                                    return child; // pas de match → on ne touche pas
                                } else {
                                    return updatePhase(child, isFromReserve)
                                }
                            }),
                        };
                    } else {
                        // Pas de P, on merge directement dans la phase E
                        return {
                            ...phase,
                            dataSend: mergeDataSend(phase.dataSend, dataSend),
                        };
                    }
                } else {
                    // details[0] est ton objet central
                    const mainDetail = details[0];

                    // On récupère ou initialise dataSend[0]
                    const currentDataSend = Array.isArray(mainDetail.dataSend) && mainDetail.dataSend.length > 0
                        ? mainDetail.dataSend[0]
                        : {};

                    // Pour chaque phase dans details (sauf index 0)
                    details.slice(1).forEach((phase: any) => {
                        if (phase.rpl_type === "A" && phase.v_consommation) {
                            const e_rpl_id = parseInt(phase.rpl_id);

                            // Cherche si ce matériel existe déjà dans dataSend
                            const index = mainDetail.dataSend.findIndex((ds: any) => ds.e_rpl_id === e_rpl_id);

                            const updatedData = {
                                e_rpl_id,
                                e_qte_consommee_uco: phase.rpl_qte_casse_ukc || 0,
                                e_qte_ret_uret: phase.rpl_qte_ret || 0,
                                e_qte_fact: phase.rpl_qte_fact_uf || 0,
                            };

                            if (index >= 0) {
                                // Met à jour l'objet existant
                                mainDetail.dataSend[index] = updatedData;
                            } else {
                                // Sinon, ajoute-le
                                mainDetail.dataSend.push(updatedData);
                            }
                        }
                    });


                }

                return {
                    ...phase,
                    sous_categorie: Array.isArray(phase?.sous_categorie)
                        ? phase.sous_categorie.map((c: any) =>
                            updatePhase(c, isFromReserve)
                        )
                        : phase.sous_categorie,

                };
            };

            return prevDetails?.map((p: any) =>
                updatePhase(p, false)
            );
        });

        // Maintenant, teste le type
        // if (phase.rpl_type === "P") {
        //     return {
        //         ...phase,
        //         dataSend: mergeDataSend(phase.dataSend, dataSend),
        //         sous_categorie: updatedChildren, // enfants déjà mis à jour
        //     };
        // }



        const savedData = localStorage.getItem(`prestaHl_${conf.user.user_code}`);
        let prestas = savedData ? JSON.parse(savedData) : [];

        const updatePrestaRecursive = (presta: any, fromReserve = false): any => {
            if (!presta || presta.rpl_id === null || presta?.rpl_id === '') return presta;
            const isFromReserve = fromReserve || presta.v_reserve === true;

            // Si c'est un E, on descend dans les enfants
            if (presta?.rpl_type === "E" && Array.isArray(presta?.sous_categorie)) {
                const hasP = presta?.sous_categorie.some((child: any) => child?.rpl_type === "P");
                if (hasP) {
                    return {
                        ...presta,
                        sous_categorie: presta?.sous_categorie.map((child: any) => {
                            if (child?.rpl_type === "P") {
                                // Vérifie si ce P contient un descendant A avec l'id du dataSend
                                const containsA = hasADeep(child, dataSend.e_rpl_id);


                                if (containsA) {
                                    return {
                                        ...child,
                                        dataSend: mergeDataSend(child.dataSend, dataSend),
                                        sous_categorie: Array.isArray(child.sous_categorie)
                                            ? child.sous_categorie.map((c: any) =>
                                                updatePrestaRecursive(c, isFromReserve)
                                            )
                                            : child.sous_categorie,
                                    };
                                }
                                return child; // pas de match → on ne touche pas
                            } else {
                                return updatePrestaRecursive(child, isFromReserve);
                            }
                        }),
                    };
                } else {
                    // Pas de P, on merge directement dans la phase E
                    return {
                        ...presta,
                        dataSend: mergeDataSend(presta.dataSend, dataSend),
                    };
                }
            } else {
                // details[0] est ton objet central
                const mainDetail = details[0];

                // On récupère ou initialise dataSend[0]
                const currentDataSend = Array.isArray(mainDetail.dataSend) && mainDetail.dataSend.length > 0
                    ? mainDetail.dataSend[0]
                    : {};

                // Pour chaque phase dans details (sauf index 0)
                details.slice(1).forEach((phase: any) => {
                    if (phase.rpl_type === "A" && phase.v_consommation) {
                        const e_rpl_id = parseInt(phase.rpl_id);

                        // Cherche si ce matériel existe déjà dans dataSend
                        const index = mainDetail.dataSend.findIndex((ds: any) => ds.e_rpl_id === e_rpl_id);

                        const updatedData = {
                            e_rpl_id,
                            e_qte_consommee_uco: phase.rpl_qte_casse_ukc || 0,
                            e_qte_ret_uret: phase.rpl_qte_ret || 0,
                            e_qte_fact: phase.rpl_qte_fact_uf || 0,
                        };

                        if (index >= 0) {
                            // Met à jour l'objet existant
                            mainDetail.dataSend[index] = updatedData;
                        } else {
                            // Sinon, ajoute-le
                            mainDetail.dataSend.push(updatedData);
                        }
                    }
                });


            }

            return {
                ...presta,
                sous_categorie: Array.isArray(presta?.sous_categorie)
                    ? presta.sous_categorie.map((c: any) =>
                        updatePrestaRecursive(c, isFromReserve)
                    )
                    : presta.sous_categorie,
            };

        };


        const updatedPrestas = prestas.map((p: any) =>
            updatePrestaRecursive(p, false)
        );

        localStorage.setItem(
            `prestaHl_${conf.user.user_code}`,
            JSON.stringify(updatedPrestas)
        );

    }, [dataSend, parentId, conf.user.user_code]);

    return (
        <>
            <div className="numericContainer">
                <p><FormattedMessage id="quantity" />: {sub.rpl_qte_liv}</p>
            </div>
            <NumericInput readOnly={isValid} name={<FormattedMessage id="quantityconsume" defaultMessage="Qté consommée" />} onChange={(value: any) => { handleInputChangePrestaConsommation(sub.rpl_id, setDetails, 'rpl_qte_casse_ukc', value); }} value={sub?.rpl_qte_casse_ukc} ></NumericInput>
            <NumericInput readOnly={isValid} name={<FormattedMessage id="quantityback" defaultMessage="Qté retournée" />} onChange={(value: any) => { handleInputChangePrestaConsommation(sub.rpl_id, setDetails, 'rpl_qte_ret', value); }} value={sub?.rpl_qte_ret} ></NumericInput>
            <NumericInput readOnly={isValid} name={<FormattedMessage id="Qtefacture" defaultMessage="Qté à facturer" />} onChange={(value: any) => { handleInputChangePrestaConsommation(sub.rpl_id, setDetails, 'rpl_qte_fact_uf', value); }} value={sub?.rpl_qte_fact_uf} ></NumericInput>
            {/* <svg className="iconValid" onClick={() => { ValidLignePrestaMaterielConso(dataSendConso, conf, setConf, showError) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg > */}
        </>
    );
};
export default RenderConsommation